module.exports = __webpack_public_path__ + "static/img/e4.12722ff3.png";